<table mat-table [dataSource]="rows">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element" class="break-word">
      <div>
        {{ (element.key | translate) + ":" }}
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="value">
    <th mat-header-cell *matHeaderCellDef></th>
    <td
      mat-cell
      *matCellDef="let element"
      class="break-word"
      (click)="clickCell($event, element)"
      (keydown.enter)="clickCell($event, element)"
      [style.color]="element.cellClick ? 'blue' : ''"
    >
      @if (element.translateValue) {
        {{ element.value | translate }}
      } @else {
        @if ((element.valuePrefix ?? "") !== (element.value ?? "")) {
          {{ element.value }}
        }
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="edit">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      @if (element.tryUpdate) {
        <mat-icon>mode_edit</mat-icon>
      }
    </td>
  </ng-container>

  <tr
    (keydown.enter)="element.tryUpdate ? element.tryUpdate() : null"
    mat-row
    *matRowDef="let element; columns: ['name', 'value', 'edit']"
    (click)="element.tryUpdate ? element.tryUpdate() : null"
    tabindex="0"
  ></tr>
</table>
